import axios from "axios";
import moment from "moment";
import { isEU, isOutsideEU } from '../../../libs/countries';

angular
  .module("AccountingBoxApp")
  .controller("SalesEditCtrl", function(
    $scope,
    $rootScope,
    $state,
    $filter,
    Sale,
    $stateParams,
    Customer,
    Account,
    VatCode,
    Attachment,
    SubAccount,
  ) {
    var vm = this;
    var sale = {};

    vm.customers = [];

    var attachment = {};
    var subAccounts;
    $scope.options = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true
    };
    $scope.optionsAccounts = {
      minLength: 2
    };
    vm.extractedWords = [];
    vm.invoiceNumberSuggestions = [];
    vm.extractedNumbers = [];

    vm.exchangeRates = []

    async function refreshExchangeRates() {
      const result = await axios.get(API_ENDPOINT + '/exchange-rates?date='+moment(sale.invoiceDate).format('YYYY-MM-DD'),{})
      vm.exchangeRates = result.data;
      vm.currencyChanged();
    }

    vm.vatCodesFiltered = function() {
      const codes = (vm.vatCodes || []).filter(function(vatCode) {

        if(vatCode.id.match(/-NL-/i)){
          return true;
        }

        if(vm.sale.customer && vm.sale.customer?.tradeName?.toLowerCase().includes('bol.com')) {
          return true;
        }


        if(!(vm.sale.customer && vm.sale.customer.address && vm.sale.customer.address.country)) {
          return false;
        }
         if(vatCode.id.match(RegExp(`-${vm.sale.customer.address.country}-`,'i'))) {
            return true;
         }

         if(isEU(vm.sale.customer.address.country) && vatCode.id.match(/-EU-/i)) {
           return true;
         }

         if(isOutsideEU(vm.sale.customer.address.country) && vatCode.id.match(/-EX-/i)) {
           return true;
         }
      })
      return codes;
    }

    vm.currencyChanged = function currencyChanged () {
      if (vm.sale.currency === "EUR") {
        vm.sale.currencyExchangeRate = 1
      }else {
        vm.sale.currencyExchangeRate = vm.exchangeRates[vm.sale.currency]
      }
      vm.totalChanged()
      $scope.$apply();
    }

    setTimeout(function() {
      loadCustomers();
      vm.accounts = Account.find({
        filter: {
          where: {
            active: true
          }
        }
      });
      vm.refreshSubAccounts();
      vm.vatCodes = VatCode.find(
        {
          filter: {
            where: {
              sale: true
            },
            order: 'category ASC'
          }
        },
        function(vatCodes) {
          initializeL();
        }
      );
    }, 1000);

    vm.refreshSubAccounts = function() {
      SubAccount.find({ filter: { where: { type: "REVENUE" } } }, function(
        subA
      ) {
        subAccounts = subA;
      });
    };

    $scope.newSubAccount = function(newTag) {
      console.log("newtag is:", newTag);
      var item = {
        description: newTag,
        type: ""
      };

      return item;
    };
    vm.subAccountSelect = function(subAccount, item) {
      if (subAccount && subAccount.new) {
        SubAccount.create(subAccount, function(subAccount) {
          item.subAccount = subAccount;
          item.subAccountId = subAccount.id;
          SubAccount.find(function(subA) {
            subAccounts = subA;
          });
        });
      }else {
        item.subAccount = subAccount;
        item.subAccountId = (subAccount && subAccount.id) || null;
      }
    };

    vm.refreshSubAccount = function(query) {
      vm.subAccounts = $filter("propsFilter")(subAccounts, {
        description: query
      });
      if (vm.subAccounts && query.length > 0) {
        vm.subAccounts.push({
          description: query,
          new: true,
          type: "REVENUE"
        });
      }
    };

    vm.showExtra = function(item) {
      if (
          (item.description && item.description.length > 0) ||
        (item.destination && item.destination.account) ||
        (item.destination && item.destination.numberOfMonths) ||
        (item.destination && item.destination.residualValue) ||
        item.showExtra
      ) {
        return true;
      } else {
        return false;
      }
    };

    vm.checkExtra = function(item) {
      if (item.showExtra) {
        item.showExtra = false;
      } else if (!item.showExtra) {
        item.showExtra = true;
      }
    };

    vm.account = function(item) {
      if (!item || !item.vatCode) {
        return "";
      }
      return _.find(vm.accounts, function(account) {
        return account.accountNumber === item.vatCode.account;
      });
    };

    vm.close = function(saved) {
      if ($state.current.name === "app.company.new.sales") {
        if (saved) {
          $scope.openNextUpload()
        } else {
          $state.go("app.company.inbox");
        }
      } else {
        window.history.back();
      }
    };
    $scope.$on("close", function() {
      vm.close();
    });

    vm.enteredInvoiceNumber = function checkUnique() {
      if (
        $state.current.name === "app.company.new.sales" &&
        // vm.sale.customer &&
        vm.sale.invoiceNumber
      ) {
        Sale.find(
          {
            filter: {
              where: {
                invoiceNumber: vm.sale.invoiceNumber
              }
            }
          },
          function(sales) {
            if (sales.length > 0) {
              var options = {
                style: "flip",
                type: "danger",
                position: "top-right",
                message:
                  "Er bestaat al een verkoopfactuur met factuurnummer <strong>" +
                  vm.sale.invoiceNumber +
                  "</strong>." //' voor <strong>' + vm.sale.customer.name + '</strong>'
              };

              $("body")
                .pgNotification(options)
                .show();
            }
          }
        );
      }
    };

    vm.focus = function(index) {
      if (sale.Lines.length - 1 === index) {
        vm.addItem();
      }
    };

    vm.addItem = function() {
      if (!sale.Lines) {
        sale.Lines = [];
      }
      var defaultVatCode = "V-NL-H";
      //first line only
      var vatType = null;

      switch (vatType) {
        case "high":
          defaultVatCode = "V-NL-H";
          break;
        case "low":
          defaultVatCode = "V-NL-L";
          break;
        case "zero":
          defaultVatCode = "V-NL-0%";
          break;
        default:
          defaultVatCode = "V-NL-H";
          break;
      }

      if ($rootScope.currentCompany.vatPeriod === "EXEMPTED") {
        defaultVatCode = "V-NL-NVT";
      }

      if ($rootScope.currentCompany.vatPeriod === "EXEMPTED_KOR") {
        defaultVatCode = "V-NL-KOR";
      }

      var defaultVatCode = vm.vatCodes.find(function(vatCode) {
        return vatCode.vatCode === defaultVatCode;
      });
      sale.Lines.push({
        description: "",
        amount: 0,
        vatCode: defaultVatCode
      });
    };

    vm.removeItem = function(item) {
      sale.Lines.splice(sale.Lines.indexOf(item), 1);
      if (sale.Lines.length === 0) {
        vm.addItem();
      }
    };

    function roundTwoDecimals(number) {
      return Math.round(number * 100) / 100;
    }

    $scope.$watch(
      "e.sale.Lines",
      function(newValue, oldValue) {
        if (
          oldValue &&
          newValue &&
          oldValue[0] &&
          newValue[0] &&
          oldValue[0].vatCode &&
          newValue[0].vatCode
        ) {
          console.log('new Value',newValue);
          console.log('old Value',oldValue);
          if (
            oldValue !== undefined &&
            newValue[0].vatCode.vatCode !== oldValue[0].vatCode.vatCode
          ) {
            vm.totalChanged(newValue[0]);
          }
        }
      },
      true
    );

    vm.totalChanged = function(l) {
      sale.totalAmount  = sale.totalCurrencyAmount / sale.currencyExchangeRate;
      var calculation = sale.totalAmount;
      if (calculation && calculation.length > 0) {
        if (calculation.indexOf("=") > -1) {
          calculation = calculation.replace("=", "");
          sale.totalAmount = roundTwoDecimals(parseFloat(eval(calculation)));
        }
      }
      var numOfFiledLines = 0;
      angular.forEach(sale.Lines, function(line, key) {
        if (Math.abs(line.amount) > 0) {
          numOfFiledLines += 1;
        }
      });
      if (numOfFiledLines < 2) {
        var line = l;
        if (!l && vm.sale.Lines) {
          line = vm.sale.Lines[0];
        }

        if (!line || !line.vatCode) {
          return;
        }
        if (line.vatCode.secondAccount !== undefined) {
          sale.Lines[0].amount = roundTwoDecimals(sale.totalAmount);
        } else {
          if (line.vatCode.rates) {
            var invoiceDate = moment(vm.sale.invoiceDate, "DD-MM-YYYY");
            var percentage = $rootScope.getVatCodePercentage(
              line.vatCode,
              invoiceDate
            );
            sale.Lines[0].amount = roundTwoDecimals(
              (sale.totalAmount / (percentage + 100)) * 100
            );
          }
        }
      }
    };

    vm.purchaseGrandTotal = function() {
      var total = 0;
      angular.forEach(sale.Lines, function(line, key) {
        total += line.amount + vm.calculateTax(line);
        if (line.vatCode && line.vatCode.secondAccount)
          total -= vm.calculateTax(line);
      });
      return total;
    };

    vm.calculateTax = function(line) {
      if (line.vatCode && line.vatCode.rates) {
        var invoiceDate = moment(vm.sale.invoiceDate, "DD-MM-YYYY");
        return roundTwoDecimals(
          ($rootScope.getVatCodePercentage(line.vatCode, invoiceDate) *
            line.amount) /
            100
        );
      } else {
        return 0;
      }
    };

    vm.saveDisabled = function() {
      //  console.log(vm.calculateBookingDifference());
      var diff = roundTwoDecimals(Math.abs(vm.calculateBookingDifference()));

      if (
        (sale.roundingDifference && vm.showRoundingDifferenceCheckbox()) ||
        diff === 0 /*&&sale.totalAmount>0*/
      ) {
        return false;
      }
      return true;
    };
    vm.showRoundingDifferenceCheckbox = function() {
      var diff = roundTwoDecimals(Math.abs(vm.calculateBookingDifference()));
      if (diff < 0.05 && diff !== 0.0) {
        return true;
      }
      return false;
    };

    vm.calculateBookingDifference = function() {
      return roundTwoDecimals(sale.totalAmount - vm.purchaseGrandTotal()); /// + vm.invoiceSubTotal();
    };

    vm.invoiceDateChanged = function() {
      if (!vm.sale.invoiceDate) return;
      refreshExchangeRates()
      vm.sale.journalDate = vm.sale.invoiceDate;
      var invoiceDate = moment(vm.sale.invoiceDate);
      var dueDateInterval = 14;

      if (
        vm.sale.customer &&
        (vm.sale.customer.paymentTerm || vm.sale.customer.paymentTerm === 0)
      ) {
        dueDateInterval = vm.sale.customer.paymentTerm;
      }
      if (
        attachment &&
        attachment.extractedData &&
        attachment.extractedData.paymentTerm
      ) {
        dueDateInterval = attachment.extractedData.paymentTerm;
      }
      var dueDate = invoiceDate.add(dueDateInterval, "days");
      if (
        attachment &&
        attachment.transactionProposal &&
        attachment.transactionProposal.dueDate
      ) {
        dueDate = moment(attachment.transactionProposal.dueDate);
      }
      vm.sale.dueDate = dueDate;

      vm.totalChanged(); // to update vat codes
    };

    vm.removeSale = function(sale) {
      if ($state.current.name === "app.company.new.sales") {
        $("#removeAttachmentModal").appendTo("app-content");
        $("#removeAttachmentModal").modal("show");
      } else {
        $("#removeModal").appendTo("#app-content");
        $("#removeModal").modal("show");
      }
    };

    vm.removeInbox = function() {
      $("#removeModal").modal("hide");
      Sale.deleteById({
        id: sale.id
      }).$promise.then(function() {
        console.log("deleted to Inbox");
      });
      setTimeout(function() {
        vm.close();
      }, 500);
    };

    vm.removePermanently = function() {
      $("#removeModal").modal("hide");
      Sale.removePermanent({
        id: sale.id
      }).$promise.then(function() {
        console.log("deleted permenantly");
      });
      setTimeout(function() {
        vm.close();
      }, 500);
    };

    vm.saveSale = function() {
      vm.saving = true;
      var saleCopy = $.extend({}, sale);
      if (saleCopy.customer) {
        saleCopy.customerId = sale.customer.id;
        delete saleCopy.customer;
      }
      saleCopy
        .$save()
        .then(function() {
          vm.close(true);
          vm.saving = false;
        })
        .catch(function(response) {
          vm.saving = false;
          if (response.data && response.data.error) {
            window.swal(
              "Opslaan mislukt",
              response.data.error.message,
              "error"
            );
          } else {
            window.swal("Opslaan mislukt", "Onbekende fout", "error");
          }
        });
    };

    function initializeL() {
      console.log("initialize lines");
      if (!sale.Lines || sale.Lines.length === 0) {
        sale.Lines = [];
        vm.addItem();
      }else if(sale.Lines) {
        sale.Lines = sale.Lines.map((line) => {
          if(line.vatCodeId && line.vatCodeId.match(/^I-/)) {
            line.vatCodeId = line.vatCode.id.replace(/^I-/, 'V-');
            line.vatCode = vm.vatCodes.find((vatCode) => vatCode.id === line.vatCodeId)
          }
          return line;
        });
      }
      vm.totalChanged();
    }

    function loadSale() {
      sale = Sale.get({
        id: $stateParams.id,
        filter: { include: ["Attachment", "customer", 'user', 'events'] }
      });
      sale.$promise.then(function() {
        console.log("extractedData:", sale.Attachment.extractedData);
        console.log(
          "transactionProposal:",
          sale.Attachment.transactionProposal
        );
        refreshExchangeRates();
      });
      vm.sale = sale;
      $scope.$parent.transaction = vm.sale;
    }

    if ($state.current.name === "app.company.new.sales") {
      console.log("app state new.sales");
      attachment = Attachment.get({
        id: $stateParams.id
      });
      attachment.$promise.then(function() {
        var extractedData = attachment.extractedData;
        var transactionProposal = attachment.transactionProposal;
        if (extractedData) {
          vm.sale.totalCurrencyAmount = transactionProposal.totalAmount;
          sale.totalCurrencyAmount = transactionProposal.totalAmount;
          vm.sale.currency = transactionProposal.currency || 'EUR';
          vm.sale.invoiceNumber = transactionProposal.invoiceNumber;
          vm.sale.invoiceDate = transactionProposal.invoiceDate;
          vm.sale.dueDate = transactionProposal.dueDate;
          vm.sale.Lines = transactionProposal.Lines;

          if (transactionProposal.customerId) {
            vm.sale.customer = new Customer(transactionProposal.customer);
            Customer.get({
              id: transactionProposal.customerId
            }).$promise.then(function(customer) {
              vm.setCustomer(customer);
            });
          }
          if (extractedData.amounts) {
            vm.extractedNumbers = extractedData.amounts;
          }

          if (extractedData.text) {
            vm.invoiceNumberSuggestions = $rootScope.invoiceNumberSuggestions(
              extractedData.text
            );
          }
        }
        console.log("extractedData:", extractedData);
        console.log("transactionProposal:", transactionProposal);
        vm.invoiceDateChanged();
        vm.sale.Attachment = attachment;
        $scope.$parent.transaction = vm.sale;
        vm.totalChanged();
      });

      sale = new Sale();
      vm.sale = sale;
      vm.sale.currency = 'EUR';
      vm.sale.currencyExchangeRate = 1

      setTimeout(function() {
        vm.invoiceDateChanged();
        if ($stateParams.id) {
          vm.sale.attachmentId = $stateParams.id;
        }
        $scope.$parent.transaction = vm.sale;
      }, 200);
    } else {
      if ($state.params.sale) {
        vm.sale = $state.params.sale;
        sale = vm.sale;
        $scope.$parent.transaction = vm.sale;
      }

      loadSale();
    }

    vm.customerSelect = function(customer) {
      vm.setCustomer(customer);
      if (customer && customer.createNew) {
        customer.tradeName = customer.name;
        $scope.openNewContactModal();
      }
    };

    function loadCustomers() {
      Customer.find(function(customers) {
        vm.customers = customers;
      });
    }

    vm.refreshCustomerList = function(query) {
      if (!query) query = "";
      vm.filteredCustomers = $filter("propsFilter")(vm.customers, {
        name: query
      });
      vm.filteredCustomers = vm.filteredCustomers.slice(0, 4);
      if (!query || query.length < 1) {
        vm.filteredCustomers = [];
      }
      vm.filteredCustomers.push(
        new Customer({
          tradeName: query,
          name: query,
          type: "business",
          createNew: true,
          bankAccountNumbers: [""]
        })
      );
    };

    vm.setCustomer = function(customer) {
      vm.sale.customer = customer;
      console.log("set customer invoice date changed");
      vm.invoiceDateChanged();
      vm.enteredInvoiceNumber();
    };

    vm.saveCustomer = function(customer) {
      Customer.upsert(customer, function(customer) {
        vm.setCustomer(customer);
        $scope.closeContactModal();
      }, function(response){
        window.swal("Opslaan mislukt", response.data.error.message, "error");
      });
    };

    vm.onCustomerCancel = function() {
      if (vm.sale.customer && vm.sale.customer.createNew) {
        vm.sale.customer = null; // set customer to null if new customer creation is canceled
      }
      $scope.closeContactModal();
    };
  });
